import type { Config } from "../../types";

export const defaultConfig: Config = {
  testInfo: {
    type: "words",
    words: 10
  },
  currentWordIndicatorAnimations: "on"
};
